import { render } from "./LayoutContainer.vue?vue&type=template&id=4ad4256e&ts=true"
import script from "./LayoutContainer.vue?vue&type=script&lang=ts"
export * from "./LayoutContainer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__